import { _ } from "src/services";

export const PackageProfileBoxShimmer: React.FC = () => (
    <div className="package-profile p-4 my-3 d-flex align-items-center">
        <div className="d-flex flex-column align-items-start flex-1">
            <h3 className="payment-box__title shimmer w-50"> </h3>
            <div className="price d-flex align-items-center w-75 shimmer"></div>
        </div>
        <button className="btn btn-submit disabled" disabled>{_("select")}</button>
    </div>
);